import React from "react";
import "./PassengerList.css";
import { DeleteOutlined } from "@ant-design/icons";

const PassengerList = ({ items, isEditable, onDelete, isApproved }) => {
  return (
    <div className="item-list-card">
      <div className="item-list">
        {items?.map((item, index) => (
          <div key={index} className="item">
            <span className="item-name">{`${index + 1}. ${
              item.fullName
            }`}</span>
            {!isApproved && isEditable ? (
              <button className="delete-icon" onClick={() => onDelete(index)}>
                <DeleteOutlined />
              </button>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PassengerList;
